import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { renderField } from '../../../../utilities/reduxForm.util'
import stripHTMLFormatter from '../../../../utilities/stripHTMLStringFormatter'
import { claimActions } from '../../../../redux/actions'

class TextAreaForm extends Component {
  handleOnBlur = e => {
    const { updateSurveyFieldData, response, type, question } = this.props
    const filteredResponse = stripHTMLFormatter(`${e.target.value}`)
    const payloadObject = { [Object.keys(response)[0]]: filteredResponse }
    updateSurveyFieldData(payloadObject, type, question)
  }

  render() {
    const { response, question } = this.props
    return (
      <div>
        <label htmlFor={`survey-textarea-${question}`} className="sr-only">
          {question}
        </label>
        <Field
          id={`survey-textarea-${question}`}
          component={renderField}
          inputType="textarea"
          type="text"
          name={Object.keys(response)[0]}
          label={Object.keys(response)[0]}
          onBlur={this.handleOnBlur}
          aria-label={question}
        />
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  updateSurveyFieldData: (...args) => dispatch(claimActions.updateSurveyFieldData(...args)),
})

const connectTextAreaForm = connect(null, mapDispatchToProps)(TextAreaForm)

export default reduxForm({ form: 'radioForm' })(connectTextAreaForm)
